export default __webpack_public_path__ + "static/media/team_mobile.39f9262d.jpg";